import { baseVariables, Modal, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledMyTripsModal = styled(Modal)`
  display: block;
  padding: ${toRem(10)};

  @media ${baseVariables.mediaQuery.sm} {
    padding: ${toRem(54)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    padding: ${toRem(112)} ${toRem(128)};
  }

  .my-trips-modal-inner {
    max-height: none;
    bottom: auto;
    margin: 0 auto;
    padding: ${toRem(20)} 0;
    overflow: hidden;

    @media ${baseVariables.mediaQuery.sm} {
      max-width: ${toRem(660)};
      padding: ${toRem(40)};
    }

    @media ${baseVariables.mediaQuery.lg} {
      max-width: ${toRem(1300)};
      padding: ${toRem(60)};
    }
  }

  .my-trips-modal-body {
    padding: 0;
  }
`;

export const StyledMyTripsModalCloseButton = styled.button`
  position: absolute;
  top: ${toRem(14)};
  right: ${toRem(14)};
  height: ${toRem(44)};
  width: ${toRem(44)};
  z-index: 200;
  cursor: pointer;
  border: none;
  background: #fff;
  padding: 0;
  border-radius: 50%;
  font-size: ${toRem(28)};
  line-height: ${toRem(28)};

  @media ${baseVariables.mediaQuery.sm} {
    top: ${toRem(36)};
    right: ${toRem(36)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    top: ${toRem(52)};
    right: ${toRem(52)};
  }
`;
